exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "agm-map, .mapContainer {\n  height: 100%;\n  width: 100%; }\n\n.widthSet {\n  max-width: 100px; }\n\n.heightSet {\n  max-height: 100px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/thechairman/Documents/projects/web-app/src/app/rim/rim.component.scss
// module id = ../../../../../src/app/rim/rim.component.scss
// module chunks = main